import React, { FC, PropsWithChildren } from 'react'

export const LandingExampleWrapper: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="flex h-96 w-full flex-col items-center justify-center gap-10 rounded-3xl bg-white">{children}</div>
  )
}
